module.exports = "<app-navadmin></app-navadmin>\n<app-menu class=\"conainer c90\"></app-menu>\n"